export default {
  name: 'auto-assignment',
  translationKey: 'auto-assignment-module',
  routePrefix: 'auto-assignment',
  routeNamePrefix: 'admin.auto-assignment',
  directRoutesAvailable: false,
}
